/* Native editor events only; no publishing, admin API, or Shopify mutations. */
(() => {
 'use strict';
 function createBridge({ready,refresh,clean,show}){
  const revisions=new WeakMap();
  const invalidate=root=>{revisions.set(root,(revisions.get(root)||0)+1);clean(root);return revisions.get(root);};
  return {async load(root){const version=invalidate(root);await ready;if(root.isConnected!==false&&version===revisions.get(root))refresh(root);},unload:invalidate,select:show};
 }
 window.LiotroEditor={createBridge};
 if(!cfg.designMode&&!window.Shopify?.designMode)return;
 function show(root){
  for(let node=root;node?.nodeType===1;node=node.parentElement)if(node.tagName==='DETAILS')node.open=true;
  const target=[root,...root.querySelectorAll('*')].find(node=>node.getBoundingClientRect().height>0);
  target?.scrollIntoView({block:'nearest'});
 }
 const bridge=createBridge({ready:LiotroReady,
  clean(root){nativeCatalogUpdater.cancel();window.LiotroRecommendations.unmount(root);window.LiotroPickup.unmount(root);window.LiotroMedia.unmount(root);window.LiotroInvoice?.unmount?.(root);window.LiotroShipping?.unmount?.(root);window.LiotroNotes?.unmount?.(root);},
  refresh(root){
   readCatalogControls(root);
   const stateNode=root.querySelector('[data-liotro-product-state]'),state=stateNode?JSON.parse(stateNode.content.textContent):null;
   const sectionSettings=root.querySelector('[data-liotro-section-settings]');
   const settings=sectionSettings?JSON.parse(sectionSettings.content.textContent):state;
   const cart=root.querySelector('[data-liotro-paused]');
   const paused=settings?.paused??(cart?cart.dataset.liotroPaused==='true':null);
   if(typeof paused==='boolean'){cfg.paused=paused;window.LiotroCommerce.setPaused(paused);}
   if(state?.product){
    const contracts=JSON.parse(root.querySelector('#liotro-product-variants')?.textContent||'[]');
    Object.assign(cfg.variantRules,Object.fromEntries(contracts.map(variant=>[String(variant.id),variant])));
    if(state.presentation)cfg.presentation[state.product.handle]=state.presentation;cfg.product=state.product;cfg.products=[...new Map([...cfg.products,state.product].map(product=>[product.handle,product])).values()];
    products=cfg.products.map(productModel).sort((a,b)=>a.rank-b.rank);
   }
   window.LiotroRecommendations.mount(root);window.LiotroPickup.mount(root);window.LiotroMedia.mount(root);window.LiotroServiceForms.mount(root);
   initializeCatalog(root);reconcileProductDescription();associateCartFields();hydrate();syncHeader();renderAccessory();
   if(state?.product){const id=root.querySelector('#product-variant')?.value||find(cfg.product.handle)?.selectedVariant?.id;if(id)updateVariant(id);}
  },show});
 document.addEventListener('shopify:section:load',event=>bridge.load(event.target).catch(error=>toast(error.message)));
 document.addEventListener('shopify:section:unload',event=>bridge.unload(event.target));
 for(const name of ['shopify:section:select','shopify:block:select'])document.addEventListener(name,event=>bridge.select(event.target));
})();
